import React from "react";
import WrapperPage from "../../components/WrapperPage";
import BaseButton from "../../components/BaseButton";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import InsightFormProtect from "../../hocs/InsightFormProtect";
import ROUTES from "../../utils/routes.js";
import "./style.scss";
export default InsightFormProtect(function InsightFormRecommendationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  return (
    <div className="insight_form_recommendation_page centering-page">
      <WrapperPage
        backBtn
        burgerMenu
        headerTitle={t("insight_form_recommendation_page.title")}
      >
        <div className="insight_form_recommendation_page__top-texts">
          <div className="insight_form_recommendation_page__left-texts">
            <div>{t("insight_form_recommendation_page.leftSide.desc1")}</div>
            <div>{t("insight_form_recommendation_page.leftSide.desc2")}</div>
          </div>
        </div>
        <div className="insight_form_recommendation_page__center-text">
          {t("insight_form_recommendation_page.centerText")}
        </div>
        <div className="insight_form_recommendation_page__useless-texts">
          <div className="insight_form_recommendation_page__bottom-left-texts">
            <div>
              {t("insight_form_recommendation_page.uselessText.leftSide.desc1")}
            </div>
            <div>
              {t("insight_form_recommendation_page.uselessText.leftSide.desc2")}
            </div>
          </div>
          <div className="insight_form_recommendation_page__bottom-right-texts">
            <div>
              {t(
                "insight_form_recommendation_page.uselessText.rightSide.desc1"
              )}
            </div>
            <div>
              {t(
                "insight_form_recommendation_page.uselessText.rightSide.desc2"
              )}
            </div>
          </div>
        </div>
        <div className="insight_form_recommendation_page__return-back">
          <BaseButton
            onClick={() =>
              navigate(ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(params.id), {
                state: { formId: params.id },
              })
            }
          >
            {t("insight_form_page.fill_in")}
          </BaseButton>
        </div>
      </WrapperPage>
    </div>
  );
});
